import React from 'react';

export const ChevronRight: React.FC<{color?: string; size?: number}> = ({color, size = 22}) => (
  <svg width={size * 0.55} height={size} viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke={color} strokeWidth="2" d="M11 0 1 11 11 22" strokeLinecap="square" />
  </svg>
);
